<template lang="pug">
    school-form(v-if='school && !isLoading', :school='school', :submit='update')
        template(slot='title') {{ $i18n.t('school.school_edit_title') }}
        template(slot='button') {{ $i18n.t('school.school_edit_button') }}
    cs-loader(v-else='')
</template>

<script>
    import { uniq, camelCase, difference } from 'lodash';
    import SchoolForm from './Form.vue';
    import SchoolApi from '../../api/school';

    export default {
        data() {
            return {
                school: null,
                isLoading: false,
                courseTypes: [],
            };
        },
        props: ['id'],
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                SchoolApi.show(this.id)
                    .then(data => {
                        this.school = data;
                        this.courseTypes = uniq(this.school.courses.map(course => camelCase(course.type)));
                        this.school.isMapAvailable = !!this.school.isMapAvailable;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            update(school) {
                return SchoolApi.update(this.id, school).then(data => {
                    const courseTypesAfterUpdate = uniq(data.courses.map(course => camelCase(course.type)));
                    const newCourses = difference(courseTypesAfterUpdate, this.courseTypes);
                    const needsToShowZeroForksModal = !!newCourses.find(course => {
                        return data.forks.every(fork => fork[`${course}Price`] === 0);
                    });

                    this.$router.push({
                        name: 'school:profile',
                        params: {
                            id: school.id,
                            needsToShowZeroForksModal,
                        },
                    });
                });
            },
        },
        components: {
            SchoolForm,
        },
    };
</script>
